import template from './template.html';

controller.$inject = [];

export function controller() {
    let vm = {};
    this.$onInit = function() {
    vm = this;

    const shifts = vm.shifts && vm.shifts.constructor === Array && vm.shifts;
    vm.shifts = ( shifts || []).map(calculateOffset);

    vm.isDisabled = vm.date < new Date().setHours(0,0,0,0) || vm.driverHoliday;
    }
    function calculateOffset(current, index, array) {
        current.offset = getHours(current.start);
        if (index !== 0) {
            current.offset -= getHours(array[index - 1].end);
        } else {
            current.offset -= 6;
            if (current.offset < 0) current.offset = 0;
        }
        if (index === array.length - 1) {
            const end = getHours(current.end);

            if (end !== 0 && end < 24) {
                current.tail = 24 - end;
            }
        }
        return current;
    }

    function getHours(d) {
        let date = new Date(d);
        //Note:  we have to use UTC functions as the service returns dates in UTC format
        let minutesSinceMidnight = (date.getUTCHours() * 60) + date.getUTCMinutes();
        let hoursAsDecimal = minutesSinceMidnight / 60;
        return hoursAsDecimal;
    }
}

export default () => ({
    template,
    controller,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: {
        shifts: '=',
        date: '=',
        driverHoliday: '='
    },
    scope: {}
});



// WEBPACK FOOTER //
// ./src/js/components/planner/day/index.js